export const DETECTIVE_TRIANGLE_IMAGE_PATH: string = '../../static/lm_triangle_as_detective.png';
export const IP_ERROR_TITLE: string = 'This IP address is not recognized.';
export const IP_ERROR_SUBTITLE_FIRST: string = 'To access this page, check your ';
export const IP_ERROR_SUBTITLE_FIRST_BOLD: string = ' VPN connectivity ';
export const IP_ERROR_SUBTITLE_SECOND: string = 'or reach out to your organization\'s '; 
export const IP_ERROR_SUBTITLE_SECOND_BOLD: string = ' LogicManager admin ';
export const IP_ERROR_SUBTITLE_THIRD: string = 'to include this IP address in their allowlist.';
